import { ProvinceFactory } from '@/Domain/Localization/Province/ProvinceFactory'
import { AxiosProvinceData } from './AxiosProvinceData'
import { Province, ProvinceFactoryError, ProvinceCode, ProvinceName } from '@/Domain/Localization/Province'

export class AxiosProvinceFactory implements ProvinceFactory<AxiosProvinceData> {
  makeProvince (data: AxiosProvinceData): Province {
    try {
      return new Province(new ProvinceCode(data.code), new ProvinceName(data.name))
    } catch (error) {
      throw new ProvinceFactoryError(error.message)
    }
  }
}
